// extracted by mini-css-extract-plugin
export default {"root":"s_RdX","static-add-widget":"lPvNw","staticAddWidget":"lPvNw"};